import { useEffect, useState } from 'react'
import useSWR from 'swr'
import { server } from '../config'
import { fetcher } from '../context/utils'
import { IVideoGallery } from '../interfaces/videoGallery'

const useVideoGallery = (id: string, isPreview: boolean) => {
  const [state, setState] = useState<IVideoGallery>()
  const { data, error } = useSWR(
    `${server}/video-gallery?titleSlug=${id}${isPreview ? '&preview=1' : ''}`,
    fetcher
  )

  useEffect(() => {
    if (data) {
      setState(data)
    }
  }, [data])
  return state
}

export default useVideoGallery
